import { render, staticRenderFns } from "./MyHome.vue?vue&type=template&id=58f8a438&scoped=true&"
import script from "./MyHome.vue?vue&type=script&lang=js&"
export * from "./MyHome.vue?vue&type=script&lang=js&"
import style0 from "./MyHome.vue?vue&type=style&index=0&id=58f8a438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8a438",
  null
  
)

export default component.exports